import Overlay from "ol/Overlay";

type TransportInfoOverlayData = {
    title?: string;
    fields: {
        label: string;
        value: string;
    }[];
};

export function buildTransportInfoOverlay(data?: TransportInfoOverlayData) {
    const element = document.createElement("div");
    element.className = "ol-popup ol-popup--road-camera-info ol-popup--transport-info";

    const content = document.createElement("div");
    content.className = "ol-popup__content";

    if (data?.title) {
        const title = document.createElement("div");
        title.className = "ol-popup__title";
        title.textContent = data.title;
        content.appendChild(title);
    }

    const rows = document.createElement("div");
    rows.className = "ol-popup__rows";

    data?.fields?.forEach((field) => {
        if (!field?.label || !field?.value) return;

        const row = document.createElement("div");
        row.className = "ol-popup__row";

        const textContainer = document.createElement("div");
        textContainer.className = "ol-popup__row-text";

        const label = document.createElement("span");
        label.className = "ol-popup__label";
        label.textContent = field.label;

        const value = document.createElement("span");
        value.className = "ol-popup__value";
        value.textContent = field.value;

        textContainer.appendChild(label);
        textContainer.appendChild(value);
        row.appendChild(textContainer);
        rows.appendChild(row);
    });

    content.appendChild(rows);
    element.appendChild(content);

    return new Overlay({
        element,
        positioning: "bottom-center",
        offset: [0, -18],
        stopEvent: true,
        insertFirst: false,
    });
}
